import { c as _c } from "react/compiler-runtime";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { MembersAutocomplete } from "@components/common/members-autocomplete/members-autocomplete";
import { XgSeatCheckbox } from "@components/table/members/assign-seats/xg-seat-checkbox";
import { ProjectRoleAutoComplete } from "@components/role/role-autocomplete/project-role-autocomplete";
import { Button, Skeleton } from "@flat-ui";
import { useInviteMembersToProject } from "@hooks/projects/use-invite-members-to-project";
import { Box, Stack } from "@mui-wrapper";
import { fetchingMembersFlagsSelector } from "@store/members/members-selector";
import { useAppSelector } from "@store/store-helper";

/** Renders autocomplete and role selection to invite members to project in share dialog */
export function InviteMemberToProjectDialog(t0) {
  const $ = _c(24);
  const {
    project
  } = t0;
  const {
    isFetchingCompanyMembers
  } = useAppSelector(fetchingMembersFlagsSelector);
  let t1;
  if ($[0] !== project) {
    t1 = {
      project,
      location: "share-project-dialog"
    };
    $[0] = project;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    autocompleteOptions,
    selectedMembers,
    helperText,
    handleMemberSelect,
    onInputChange,
    isValidInput,
    getChipColor,
    giveXgSeatsCheckbox,
    selectedRole,
    setSelectedRole,
    canAssignProjectRoles,
    isLoading,
    shouldSendInviteDisable,
    handleConfirm
  } = useInviteMembersToProject(t1);
  if (isFetchingCompanyMembers) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <Skeleton variant="rectangular" height="47px" />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] !== autocompleteOptions || $[4] !== getChipColor || $[5] !== handleMemberSelect || $[6] !== helperText || $[7] !== isLoading || $[8] !== isValidInput || $[9] !== onInputChange || $[10] !== selectedMembers) {
    t2 = <MembersAutocomplete isRequired={true} hasAutoFocus={true} label="Members" helperText={helperText} onInputChange={onInputChange} options={autocompleteOptions} selectedOptions={selectedMembers} handleMemberSelect={handleMemberSelect} isValid={isValidInput} getChipColor={getChipColor} isDisabled={isLoading} />;
    $[3] = autocompleteOptions;
    $[4] = getChipColor;
    $[5] = handleMemberSelect;
    $[6] = helperText;
    $[7] = isLoading;
    $[8] = isValidInput;
    $[9] = onInputChange;
    $[10] = selectedMembers;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  let t3;
  if ($[12] !== canAssignProjectRoles || $[13] !== giveXgSeatsCheckbox || $[14] !== handleConfirm || $[15] !== isLoading || $[16] !== selectedMembers.length || $[17] !== selectedRole || $[18] !== setSelectedRole || $[19] !== shouldSendInviteDisable) {
    t3 = selectedMembers.length > 0 && <>{canAssignProjectRoles && <Box sx={{
        mt: SPACE_ELEMENTS_OF_MODAL
      }}><ProjectRoleAutoComplete isRequired={true} selectedRole={selectedRole} onChange={role => setSelectedRole(role)} isDisabled={isLoading} /></Box>}{giveXgSeatsCheckbox && <XgSeatCheckbox {...giveXgSeatsCheckbox} />}<Button variant="ghost" disabled={shouldSendInviteDisable} isLoading={isLoading} onClick={handleConfirm} sx={{
        mt: SPACE_ELEMENTS_OF_MODAL
      }}>Invite</Button></>;
    $[12] = canAssignProjectRoles;
    $[13] = giveXgSeatsCheckbox;
    $[14] = handleConfirm;
    $[15] = isLoading;
    $[16] = selectedMembers.length;
    $[17] = selectedRole;
    $[18] = setSelectedRole;
    $[19] = shouldSendInviteDisable;
    $[20] = t3;
  } else {
    t3 = $[20];
  }
  let t4;
  if ($[21] !== t2 || $[22] !== t3) {
    t4 = <Stack>{t2}{t3}</Stack>;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
  } else {
    t4 = $[23];
  }
  return t4;
}